import { Store } from "../interfaces/IStore";

export const filterStores = (stores: Store[], businessFilters: string | undefined, productFilters: string[]) => {
  const filters = []
  if (businessFilters) {
    filters?.push(`type-${businessFilters}`);
  }
  if (productFilters) {
    productFilters?.forEach(p => filters.push(`product-${p}`));
  }
  return stores?.filter(store => (!businessFilters || store?.business_type === businessFilters) && (productFilters?.length === 0 || store?.products?.some(filter => productFilters?.includes(filter))))
}